import { Debouncer } from "../../../../utils/Helpers"

const generatedStyles = new Map()
const styleDebouncer = new Debouncer()

export const resolveStyle = (desktop, mobile) => {
    if (!window.builder_dev_mode) {
        return window.innerWidth > 640 ? desktop : mobile
    } else {
        const view = document.querySelector(".widget-view")

        if (view) {
            const { width } = view.getBoundingClientRect()

            return width > 640 ? desktop : mobile
        }

        const isMobile = new URLSearchParams(window.location.search).get("view") === "MOBILE"

        return isMobile ? mobile : desktop
    }
}

function hashString(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i)
        hash |= 0
    }
    return "s-" + Math.abs(hash).toString(36)
}

export const addCSSClass = (styleObj, id) => {
    const styleString = JSON.stringify(styleObj, Object.keys(styleObj).sort()) // Упорядочиваем ключи
    const className = hashString(styleString)

    if (!generatedStyles.has(className)) {
        const css = `.${className} { ${Object.entries(styleObj)
            .map(([key, value]) => `${key.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${value};`)
            .join(" ")} }`

        const styleTag = document.createElement("style")

        styleTag.innerHTML = css
        styleTag.id = className
        styleTag.setAttribute("data-cta-element", id)
        document.head.appendChild(styleTag)

        styleDebouncer.exec(() => {
            const tags = document.querySelectorAll(`[data-cta-element='${id}']`)

            for (let i = 0; i < tags.length; i++) {
                if (!document.querySelector(`.${tags[i].id}`)) {
                    styleTag.parentNode.removeChild(document.querySelector(`style#${tags[i].id}`))
                    generatedStyles.delete(tags[i].id)
                }
            }
        }, 1000)

        generatedStyles.set(className, css)
    }

    return className
}

export const containerBlock = () => ({
    width: "100%",
    height: "100%",
    display: "flex"
})

export const noneEvents = () => ({
    pointerEvents: "none"
})

export const allEvents = () => ({
    pointerEvents: "all"
})

export const typedWidth = ({ value, type }) => ({
    maxWidth: "100%",
    width: `${value}${type}`
})

export const typed = ({ value, type }) => `${value}${type}`

export const typedHeight = ({ value, type }) => ({
    height: "max-content",
    minHeight: `${value}${type}`
})

const resolveIdent = (ident = [0, 0, 0, 0]) => {
    return ident.map(n => (n !== "auto" ? `${n}px` : n)).join(" ")
}

export const resolvePadding = padding => {
    return {
        padding: resolveIdent(padding)
    }
}

export const resolveContainer = container => {
    if (!container) {
        return {}
    }
    const isJustify = container.align === "justify"
    return {
        padding: resolveIdent(container.padding),
        margin: resolveIdent(container.margin),
        alignSelf: isJustify ? "center" : container.align,
        backgroundColor: container.backgroundColor,
        maxWidth: isJustify ? "100%" : `${container.maxWidth?.value}${container.maxWidth?.type}`,
        width: "100%"
    }
}

export const resolveShadow = shadow => {
    if (shadow && shadow.hasShadow) {
        return {
            boxShadow: shadow.hasShadow
                ? `${shadow.horizontal}px ${shadow.vertical}px ${shadow.blur}px ${shadow.color}`
                : "none"
        }
    }
}

export const resolveMargin = margin => {
    return {
        margin: resolveIdent(margin)
    }
}

export const resolveBorderRadius = borderRadius => {
    const style = {}
    if (Array.isArray(borderRadius)) {
        const [left, top, right, bottom] = borderRadius

        style.borderTopLeftRadius = `${left}px`
        style.borderTopRightRadius = `${top}px`
        style.borderBottomRightRadius = `${right}px`
        style.borderBottomLeftRadius = `${bottom}px`
    } else {
        style.borderRadius = `${borderRadius}px`
    }

    return style
}

export const resolveBorder = border => {
    let style = {
        borderStyle: border.style,
        borderColor: border.color
    }
    if (Array.isArray(border.width)) {
        const [left, top, right, bottom] = border.width

        style.borderLeftWidth = `${left}px`
        style.borderTopWidth = `${top}px`
        style.borderRightWidth = `${right}px`
        style.borderBottomWidth = `${bottom}px`
    } else {
        style.borderWidth = `${border.width}px`
    }

    if (border.radius) {
        style = {
            ...style,
            ...resolveBorderRadius(border.radius)
        }
    }

    return style
}

export const resolveBackground = background => {
    if (!background) {
        return {}
    }
    let style = {
        backgroundColor: background.color
    }
    if (background.border) {
        style = {
            ...style,
            ...resolveBorder(background.border)
        }
    }

    if (background.src) {
        style = {
            ...style,
            backgroundImage: `url('${background.src}')`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
        }
    }

    return style
}

export const toPx = val => (val ? `${val}px` : 0)

export const resolveFont = font => {
    const style = {
        fontFamily: `${font.family} !important`,
        fontSize: `${font.size}px`
    }

    if (font.weight) {
        style.fontWeight = font.weight
    }
    if (font.height) {
        style.lineHeight = `${font.height}%`
    }
    if (font.color) {
        style.color = font.color
    }

    return style
}
